module.exports = __webpack_public_path__ + "img/nairobi4.95e98d9b.jpg";